import { api } from './client';

export interface PriceMasterEntry {
  id: number;
  priceList: string;
  discount: string | null;
  specialDiscount: string | null;
  status: string;
  remarks: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PriceMasterListResult {
  data: PriceMasterEntry[];
  total: number;
}

export interface PriceMasterFilter {
  priceList?: string;
  status?: string;
}

export interface UpsertPriceMasterPayload {
  priceList: string;
  discount?: number | null;
  specialDiscount?: number | null;
  status?: string;
  remarks?: string | null;
}

export const CUSTOMER_TYPES = ['Wholesaler', 'Distributor', 'Retailer', 'MBO & SiS', 'Corporate & Projects', 'Architect', 'Customization'];

export function priceMasterExportPath(filter: PriceMasterFilter = {}): string {
  const params = new URLSearchParams();
  if (filter.priceList) params.set('priceList', filter.priceList);
  if (filter.status)    params.set('status',    filter.status);
  const qs = params.toString();
  return `/masters/price-master/export.xlsx${qs ? `?${qs}` : ''}`;
}

export function priceMasterImportTemplatePath(): string {
  return '/masters/price-master/import-template.xlsx';
}

export async function listPriceMaster(filter: PriceMasterFilter = {}): Promise<PriceMasterListResult> {
  const r = await api.get<PriceMasterListResult>('/masters/price-master', { params: filter });
  return r.data;
}

export async function upsertPriceMaster(payload: UpsertPriceMasterPayload): Promise<PriceMasterEntry> {
  const r = await api.post<PriceMasterEntry>('/masters/price-master', payload);
  return r.data;
}

export async function deletePriceMaster(id: number): Promise<void> {
  await api.delete(`/masters/price-master/${id}`);
}

export async function deleteAllPriceMaster(): Promise<{ deleted: number }> {
  const r = await api.delete<{ deleted: number }>('/masters/price-master/all');
  return r.data;
}

export async function importPriceMaster(file: File): Promise<import('./items').ImportResult> {
  const fd = new FormData();
  fd.append('file', file);
  const r = await api.post<import('./items').ImportResult>('/masters/price-master/import', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return r.data;
}
